export default "<app-main-layout></app-main-layout>"